const projectList = {
  acryl_on_canvas: [
    {
      projectName: "",
      projectDescription: "",
      projectThumbNailLink: "./assets/pntgs/depths.jpg",
      projectTech: ""
    },
    {
      projectName: "",
      projectDescription: "",
      projectThumbNailLink: "./assets/pntgs/baloons.jpg",
      projectTech: ""
    },
    {
      projectName: "",
      projectDescription: "",
      projectThumbNailLink: "./assets/pntgs/road.jpg",
      projectTech: ""
    },
    {
      projectName: "Field flowers",
      projectDescription: "\"Aku no Hana\" by Shuzo Oshimi inspired nightmare-scape.",
      projectThumbNailLink: "./assets/pntgs/field_flowers.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Highland",
      projectDescription: "A dreamscape.",
      projectThumbNailLink: "./assets/pntgs/highland.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Impact",
      projectDescription: "Heroic figure in his final moments.",
      projectThumbNailLink: "./assets/pntgs/impact.jpg",
      projectTech: "Acryl on canvas ..\"/..\""
    },
    {
      projectName: "Risen",
      projectDescription: "Fast paced colourful awakening",
      projectThumbNailLink: "./assets/pntgs/risen.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "A Whale",
      projectDescription: "There is a whale. And it is headed down.",
      projectThumbNailLink: "./assets/pntgs/a_whale.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Absolute Control",
      projectDescription: "Before even hatched, a string is attached.",
      projectThumbNailLink: "./assets/pntgs/absolute_control.jpg",
      projectTech: "Acryl on canvas ..\"/..\""
    },
    {
      projectName: "Anxiety",
      projectDescription: "Severe panic eye floatie.",
      projectThumbNailLink: "./assets/pntgs/anxiety.jpg",
      projectTech: "Acryl on canvas ..\"/..\""
    },
    {
      projectName: "Ascension",
      projectDescription: "First (Not really) painting. Feedback for this one served as encouragement for the author practicing painting.",
      projectThumbNailLink: "./assets/pntgs/ascension.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Basket nebula",
      projectDescription: "Based on general probability this exact nebula is out there somewhere. Probably.",
      projectThumbNailLink: "./assets/pntgs/basket_nebula.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Bottom Feeder",
      projectDescription: "\"14\" by Peter Clines inspired Lovecraftian depth terror.",
      projectThumbNailLink: "./assets/pntgs/bottom_feeder.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Crashing down",
      projectDescription: "In the continuing rush, you are aiming to crash.",
      projectThumbNailLink: "./assets/pntgs/crashing_down.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Crosses in crimson ocean",
      projectDescription: "Evangelion inspired nightmare-scpape.",
      projectThumbNailLink: "./assets/pntgs/croses_in_ocean.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Detachment",
      projectDescription: "The 3 mental states of advanced paranoia.",
      projectThumbNailLink: "./assets/pntgs/detachment.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Festive",
      projectDescription: " A pumpkin surounded by color swirls.",
      projectThumbNailLink: "./assets/pntgs/festive.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
    {
      projectName: "Some whales",
      projectDescription: "Some whales.",
      projectThumbNailLink: "./assets/pntgs/some_whales.jpg",
      projectTech: "Acryl on canvas 11\"/14\""
    },
  ]
}
export default projectList;
